import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-xs leading-4.5 text-gray-70" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs leading-4.5 text-gray-70"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["href"]

import { contextPath } from "@ocm/services/ocm-object";
import { store } from "@/state/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFootnote',
  setup(__props) {

function auszeichnungenLink() {
	const _contextPath = store.isClassic ? "de-de/shop/" : contextPath;
	return `${window.location.origin}${_contextPath}/auszeichnungen/`;
}

return (_ctx: any,_cache: any) => {
  return (_unref(store).isModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("foot_note.recommended_retail_price")), 1),
        (!_unref(store).isLogin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t("foot_note.biggest_outlet_explanation")) + " ", 1),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("foot_note.more_information")) + " ", 1),
              _createElementVNode("a", {
                href: auszeichnungenLink(),
                class: "break-words underline",
                target: "_blank",
                rel: "noopener"
              }, _toDisplayString(auszeichnungenLink()), 9, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})